module.exports = __webpack_public_path__ + "media/images/banner/becos/onlineStore-fa49fca5a83d382d6872040c175f1663.jpg";